import React from 'react';
import {
  NOTICE_OPTIONS,
  WINDOW_OPTIONS,
  INTERVAL_OPTIONS,
  BUFFER_OPTIONS,
} from '../../lib/barberSchedule/helpers';

/**
 * "Booking policy" card — the 4 dropdowns at the top of the schedule
 * page. Pure controlled component so the container owns state + save.
 */
export const PolicyPanel = ({
  minNotice, setMinNotice,
  bookingWindow, setBookingWindow,
  slotInterval, setSlotInterval,
  bookingBuffer, setBookingBuffer,
}) => (
  <section className="panel" data-testid="sched-policy-panel">
    <div className="ph">
      <h3>Booking policy</h3>
    </div>
    <div className="panel-body">
      <div className="policy-grid">
        <div className="field">
          <label>Minimum notice</label>
          <select
            className="inp"
            value={minNotice}
            onChange={(e) => setMinNotice(Number(e.target.value))}
            data-testid="sched-notice"
          >
            {NOTICE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          <small className="mute">Slots earlier than this are hidden from customers.</small>
        </div>
        <div className="field">
          <label>Booking window</label>
          <select
            className="inp"
            value={bookingWindow}
            onChange={(e) => setBookingWindow(Number(e.target.value))}
            data-testid="sched-window"
          >
            {WINDOW_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          <small className="mute">How far in the future customers can pick a slot.</small>
        </div>
        <div className="field">
          <label>Slot interval</label>
          <select
            className="inp"
            value={slotInterval}
            onChange={(e) => setSlotInterval(Number(e.target.value))}
            data-testid="sched-interval"
          >
            {INTERVAL_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          <small className="mute">Grid step for available start times. Service length still filters out overlaps.</small>
        </div>
        <div className="field">
          <label>Buffer between bookings</label>
          <select
            className="inp"
            value={bookingBuffer}
            onChange={(e) => setBookingBuffer(Number(e.target.value))}
            data-testid="sched-buffer"
          >
            {BUFFER_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          <small className="mute">Extra time added after every booking. Applies to walk-ins and prebooked.</small>
        </div>
      </div>
    </div>
  </section>
);
